import { create } from 'zustand';
import type { UserSummary } from '../api/types';

// 권위: docs/ARCH_DASHBOARD.md §6.0.3, §3.1
// access_token 은 메모리에만 — 페이지 새로고침 시 /api/v1/auth/refresh (쿠키) 로 재획득.
// refresh_token 은 HttpOnly 쿠키 — JavaScript 로 접근 불가 (XSS 방어).

export interface AuthState {
  accessToken: string | null;
  user: UserSummary | null;
  // 최초 진입 시 refresh 시도가 진행 중이면 true. UI 는 이 동안 스피너를 표시한다.
  bootstrapping: boolean;

  setSession: (accessToken: string, user: UserSummary) => void;
  setAccessToken: (accessToken: string) => void;
  setUser: (user: UserSummary) => void;
  clear: () => void;
  setBootstrapping: (v: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  bootstrapping: true,

  setSession: (accessToken, user) => set({ accessToken, user }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setUser: (user) => set({ user }),
  clear: () => set({ accessToken: null, user: null }),
  setBootstrapping: (v) => set({ bootstrapping: v }),
}));

// store 외부(예: axios interceptor)에서 최신 값을 스냅샷으로 읽기 위한 헬퍼
export const authSnapshot = {
  getAccessToken: (): string | null => useAuthStore.getState().accessToken,
};
